import React from 'react';
import { Linkedin, Instagram } from 'lucide-react';
import styles from './Team.module.css';

/* Paste profile URLs into linkedin / instagram as they arrive. An empty
   string renders the icon as a muted placeholder rather than a dead link. */
const teamMembers = [
  {
    initials: 'SAB',
    name: 'Syamala Apurupa Burra',
    role: 'Director',
    description: 'Emerging entrepreneur with deep intuition',
    linkedin: '',
    instagram: ''
  },
  {
    initials: 'AS',
    name: 'Ankit Sharma',
    role: 'Director, Business Development',
    description: 'Expert in data modeling and visualizations.',
    linkedin: '',
    instagram: ''
  },
  {
    initials: 'RP',
    name: 'Ramesh ChandraPola',
    role: 'Lead Developer',
    description: 'Builds the software behind the dashboards.',
    linkedin: '',
    instagram: ''
  },
  {
    initials: 'DS',
    name: 'Drasthi Shah',
    role: 'Lead Product Engineer',
    description: 'Shapes how the product works for its users.',
    linkedin: '',
    instagram: ''
  }
];

const SocialLink = ({ href, label, children }) => {
  if (!href) {
    return (
      <span className={styles.socialPlaceholder} aria-hidden="true">
        {children}
      </span>
    );
  }
  return (
    <a
      className={styles.socialLink}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
    >
      {children}
    </a>
  );
};

const Team = () => (
  <section id="team" className={`${styles.aboutTeam} section`}>
    <div className="container">
      <h2 className="section-title fade-in">About Our Team</h2>
      <div className={styles.teamGrid}>
        {teamMembers.map((member) => (
          <div key={member.name} className={`${styles.teamMember} fade-in`}>
            <div className={styles.teamAvatar}>{member.initials}</div>
            <h3 className={styles.teamName}>{member.name}</h3>
            <p className={styles.teamRole}>{member.role}</p>
            <p className={styles.teamDescription}>{member.description}</p>
            <div className={styles.teamSocials}>
              <SocialLink href={member.linkedin} label={`${member.name} on LinkedIn`}>
                <Linkedin size={16} aria-hidden="true" />
              </SocialLink>
              <SocialLink href={member.instagram} label={`${member.name} on Instagram`}>
                <Instagram size={16} aria-hidden="true" />
              </SocialLink>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Team;
